import React, { useState } from "react";
import Submitted from "assets/icons/Submitted.svg";
import { Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ViewIcon from "assets/icons/View.svg";
import Section from "../common/Details";
import {
  generateAvailabeJob,
  generateConfirmedJobDetails,
  generateViewRecentSubmittedRequestDetails,
  MODAL_STATES,
} from "../../constant/Home/Jobs";
import GenericModal from "../../Ui/Modal";
import ButtonComponent from "../../Ui/Button";
import JobSummaryModal from "./JobSummaryModal";

const CompletedRequest = ({ setActiveStep, jobData = {}, summarySections = [] }) => {
  const navigate = useNavigate();
  const [modalState, setModalState] = useState(
    summarySections.length ? MODAL_STATES.JOB_SUMMARY : MODAL_STATES.JOB_DETAILS
  );
  const [viewJob, setViewJob] = useState(false);
  const [showSummary, setShowSummary] = useState(false);

  const content = {
    [MODAL_STATES.JOB_SUMMARY]: (
      <Section
        sections={summarySections}
        className="max-h-[70vh] overflow-y-auto pr-2"
      />
    ),
    [MODAL_STATES.JOB_DETAILS]: (
      <Section sections={generateViewRecentSubmittedRequestDetails(jobData)} />
    ),
    [MODAL_STATES.JOB_CONFIRMED]: (
      <Section sections={generateConfirmedJobDetails(jobData)} />
    ),
  };

  const title = {
    [MODAL_STATES.JOB_SUMMARY]: "Review Your Submission",
    [MODAL_STATES.JOB_DETAILS]: "Job Details",
    [MODAL_STATES.JOB_CONFIRMED]: "Summary of Job  Details",
  };

  const footer = {
    [MODAL_STATES.JOB_SUMMARY]: (
      <div className="flex w-full justify-between gap-2 flex-wrap">
        <ButtonComponent
          variant="outlined"
          onClick={() => setModalState(MODAL_STATES.JOB_DETAILS)}
        >
          View backend job
        </ButtonComponent>
        <div className="flex gap-2">
          <ButtonComponent onClick={() => setModalState("")}>Close</ButtonComponent>
          <ButtonComponent
            bgColor="#3CAB5C"
            color="#FFFFFF"
            onClick={() => setModalState(MODAL_STATES.JOB_DETAILS)}
          >
            Continue
          </ButtonComponent>
        </div>
      </div>
    ),
    [MODAL_STATES.JOB_DETAILS]: <div className="" />,
    [MODAL_STATES.JOB_CONFIRMED]: (
      <div className="flex w-full justify-between">
        <ButtonComponent
          onClick={() => setModalState(MODAL_STATES.JOB_DETAILS)}
        >
          Back
        </ButtonComponent>
        <ButtonComponent
          bgColor="#3CAB5C"
          color="#FFFFFF"
          onClick={() => setModalState("")}
        >
          Exit
        </ButtonComponent>
      </div>
    ),
  };

  const handleClose = () => {
    setModalState("");
    navigate("/dashboard");
  };

  const handleSummaryClose = () => setShowSummary(false);

  const handleViewDetailsClick = () => {
    if (summarySections.length) {
      setShowSummary(true);
    } else {
      setModalState(MODAL_STATES.JOB_DETAILS);
      setViewJob(true);
    }
  };

  const handleSummaryContinue = () => {
    setShowSummary(false);
    setModalState(MODAL_STATES.JOB_DETAILS);
    setViewJob(true);
  };

  return (
    <div className="flex justify-center items-center flex-col md:gap-8 gap-4 ">
      {" "}
      <div className="flex flex-col gap-2 justify-center items-center ">
        <img
          className="md:h-[144px] md:w-[144px] h-[100px] w-[100px]"
          src={Submitted}
          alt="Submitted"
        />
        <h2 className="text-[#242424]  text-center text-[24px] font-medium">
          Your maintenance request has been submitted.
        </h2>
        <p className="text-[#595959] text-[14px] font-medium">
          We'll keep you updated as the job moves forward
        </p>
      </div>
      <div className="flex sm2:flex-row flex-col md:gap-4 gap-2 justify-center items-center ">
        {" "}
        <Button
          startIcon={<ArrowBackIcon />}
          component={Link}
          to="/dashboard"
          type="button"
          disableRipple
          disableFocusRipple
          sx={{
            color: "#333333",
            padding: "12px",
            border: "1px solid #ECECEC",
            textDecoration: "none",
            WebkitTapHighlightColor: "transparent",
            "&:hover": { textDecoration: "none", color: "#333333" },
            "&:visited": { color: "#333333" },
            "&:focus": { outline: "none" },
            "&.Mui-focusVisible": { outline: "none" },
          }}
        >
          Return to Dashboard
        </Button>
        <button
          onClick={handleViewDetailsClick}
          className="bg-[#3cab5c] text-nowrap flex gap-2 items-center justify-center h-12   w-fit hover:bg-[#3c8f47] text-white  px-3 sm:text-[14px] lg:text-[16px]   py-3 rounded-xl font-medium"
        >
          <img
            src={ViewIcon}
            alt="View"
            className="w-[14px] h-[14px] svg-drop "
          ></img>{" "}
          View request details
        </button>
        {viewJob && (
          <GenericModal
            logo={modalState === MODAL_STATES.JOB_CONFIRMED}
            logoDetail={
              modalState === MODAL_STATES.JOB_CONFIRMED
                ? "You're Booked! Time to Get to Work."
                : null
            }
            open={viewJob}
            onClose={handleClose}
            title={title[modalState]}
            children={content[modalState]}
            footer={footer[modalState] || null}
            maxWidth="953px"
          />
        )}
        {showSummary && (
          <JobSummaryModal
            open={showSummary}
            onClose={handleSummaryClose}
            sections={summarySections}
            mode={MODAL_STATES.JOB_SUMMARY}
            onViewBackend={handleSummaryContinue}
            onContinue={handleSummaryContinue}
          />
        )}
      </div>
    </div>
  );
};

export default CompletedRequest;
